import Icon from '@/atoms/Icon/Icon';
import Tooltip from '@/atoms/Tooltip/Tooltip';
import Props from './typings';

const InfoIcon = ({text, tooltipPosition = 'top', size, color}: Props) => {
  return (
    <Tooltip content={text} placement={tooltipPosition}>
      <span>
        <Icon type="information" fontSize={size} color={color} label="Information" />
      </span>
    </Tooltip>
  );
};

export default InfoIcon;
